/**
* PURPOSE: Catálogo visual de estados de usuario.
* RESPONSIBILITIES: Centraliza texto, color y orden de estados para el panel de permisos/usuarios.
* COLLABORATORS: src/sections/UserSection.jsx, src/admin/CreateUser/Modal/ModalCreateUser/ModalCreateUser.jsx, src/admin/CreateUser/Modal/ModalEditUser/ModalEditUser.jsx
* ROUTE: src/utils/userState.js
*/
export const USER_STATE = {
  1: {
    label: "Activo",
    description: "Puede loguearse y se muestra normalmente.",
    className: "bg-emerald-50 text-emerald-700 ring-emerald-200",
    order: 1,
  },
  0: {
    label: "Inactivo",
    description: "Puede loguearse, pero queda marcado como poco activo.",
    className: "bg-amber-50 text-amber-700 ring-amber-200",
    order: 2,
  },
  [-1]: {
    label: "Inhabilitado",
    description: "No puede loguearse, pero aparece en la lista.",
    className: "bg-red-50 text-red-700 ring-red-200",
    order: 3,
  },
  [-2]: {
    label: "Eliminado",
    description: "Eliminado lógico. No aparece en la lista y no puede loguearse.",
    className: "bg-slate-100 text-slate-600 ring-slate-200",
    order: 4,
  },
};

export const USER_STATE_OPTIONS = [
  { value: 1, label: "Activo" },
  { value: 0, label: "Inactivo" },
  { value: -1, label: "Inhabilitado" },
  { value: -2, label: "Eliminado lógico" },
];

export function getUserStateMeta(state) {
  return USER_STATE[Number(state)] || USER_STATE[1];
}

export function getUserStateOrder(state) {
  return getUserStateMeta(state).order;
}
